import React from "react";
import useEditService from "../hooks/useEditService";
import useUploadFiles from "../../../services/hooks/useUploadFiles";

// components
import Modal from "../../../component/ui/modal";
import Tab from "../../../component/ui/tabs/Tabs";
import Upload from "../../../component/modals/upload";
import TextInput from "../../../component/element/forms/TextInput";
import TextMultipleInput from "../../../component/element/forms/TextMultipleInput";

// constants

// types and state
import { edit_service, get_service } from "../../../services/apis/services";
import { useAppDispatch } from "../../../store";
import RichText from "../../../component/element/forms/RichText";

type IEditService = {
  id: string;
  show: boolean;
  onCancel: () => void;
};

const EditService: React.FC<IEditService> = ({ id, show, onCancel }) => {
  const dispatch = useAppDispatch();
  const { data, err, dataSet, errSet } = useEditService();
  const { loader, uploadFile } = useUploadFiles();

  const onLoad = React.useCallback(() => {
    if (id) get_service(dispatch, id);
  }, [dispatch, id]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const onsubmit = async () => {
    let err;
    if (!data.id) {
      err = true;
      errSet((prev) => ({ ...prev, id: "warning" }));
    }
    if (!data.name) {
      err = true;
      errSet((prev) => ({ ...prev, name: "warning" }));
    }
    if (!data.description) {
      err = true;
      errSet((prev) => ({ ...prev, description: "warning" }));
    }
    if (err) return;
    const response = await edit_service(data, dispatch);
    if (response) onCancel();
  };

  return (
    <Modal
      title="Edit Service"
      open={show}
      onClose={onCancel}
      onOkClick={onsubmit}
    >
      <div className="space-y-6">
        <div>
          <Upload
            title="Upload Image"
            name="description"
            status={err.image}
            loading={loader}
            completed={!!data.image}
            imgPreview={data.image}
            onChange={async (fileOrFiles) => {
              const paths = await uploadFile(fileOrFiles as File, "services");
              if (paths.length > 0) {
                const img_path = paths[0]?.base_url + "/" + paths[0]?.path;
                dataSet((prev) => ({ ...prev, image: img_path }));
                errSet((prev) => ({ ...prev, image: "" }));
              }
            }}
          />
        </div>

        <div>
          <TextInput
            value={data.name}
            label="Name"
            name="name"
            placeholder="Service Name"
            type="text"
            status={err.name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const { name, value } = e.target;
              dataSet((prev) => ({ ...prev, [name]: value }));
              errSet((prev) => ({ ...prev, [name]: "" }));
            }}
          />
        </div>

        <div>
          <div className="mb-6">
            <TextMultipleInput
              label="Packages"
              onChange={(res) => {
                dataSet((prev) => ({
                  ...prev,
                  packages: [...data.packages, res],
                }));
                errSet((prev) => ({ ...prev, packages: "" }));
              }}
            />
          </div>
          <div>
            {data.packages.length > 0 && (
              <div className="border p-1 rounded-lg flex">
                {data.packages.map((item, index) => (
                  <Tab key={index} value={item} />
                ))}
              </div>
            )}
          </div>
        </div>

        <RichText
          label="Description"
          value={data.description}
          placeholder="Desccription"
          onChange={(value) => {
            dataSet((prev) => ({ ...prev, description: value }));
            errSet((prev) => ({ ...prev, description: "" }));
          }}
        />
      </div>
    </Modal>
  );
};

export default EditService;
